<template>
	<sf-modal-layout size="xl" :title="title" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="searchContainer" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container ref="table" @close="close" @reload="reload" />
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="() => close()">
				{{ getMessage_('SWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/MenuManagement/store/helpers';
import SearchContainer from './Search/SearchContainer.vue';
import TableContainer from './Table/TableContainer.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchContainer, TableContainer },
	data() {
		return {
			show: false,
			title: '메뉴명 다국어 입력'
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open() {
			this.show = true;

			if (this.$refs.searchContainer != undefined) {
				this.$refs.searchContainer.searchList();
			}
		},
		close() {
			// console.log('@@@@ popup close')
			// console.log('@@@@ this.$refs.table.selectedRow: ', this.$refs.table.selectedRow)

			this.setSearchParam_({ key: 'msgKey', value: null });
			this.setSearchParam_({ key: 'msgLoc', value: null });
			this.setSearchParam_({ key: 'msgText', value: null });

			this.$refs.searchContainer.reset();

			this.$emit('SetName', this.$refs.table.selectedRow);

			this.show = false;

			this.$refs.msgTable.reset();
		},
		reload(currentPage = 1, pageUnit = 10) {
			this.$refs.searchContainer.searchList(currentPage, pageUnit);
		}
	}
};
</script>
<style></style>
